import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export const ProtectedRoute = ({ children, isChangePasswordPage = false }) => {
  const { isAuthed, mustChange } = useAdminAuth();
  if (!isAuthed) return <Navigate to="/admin/login" replace />;
  // Force the temporary-password change before anything else.
  if (mustChange && !isChangePasswordPage) {
    return <Navigate to="/admin/change-password" replace />;
  }
  // If they somehow land on change-password but don't need it, send them home.
  if (!mustChange && isChangePasswordPage) {
    return <Navigate to="/admin" replace />;
  }
  return children;
};
